__turbopack_context__.v({
  "enterYourEmail": "text-field-module-scss-module__6iHPdG__enterYourEmail",
  "error": "text-field-module-scss-module__6iHPdG__error",
  "errorText": "text-field-module-scss-module__6iHPdG__errorText",
  "label": "text-field-module-scss-module__6iHPdG__label",
  "row": "text-field-module-scss-module__6iHPdG__row",
  "textField": "text-field-module-scss-module__6iHPdG__textField",
});
